import * as React from 'react';
import styled, { css } from 'styled-components';

import { themeGet } from '../../theme/utils';
import { InputBase } from './InputBase';

export interface NumberInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  unit?: string;
  value?: number;
}

export const hideNumberInputSpinner = css`
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-appearance: none;
    margin: 0;
  }
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -moz-appearance: textfield;
` as any;

export const NumberInputStyled = styled(InputBase).attrs<NumberInputProps>(() => ({
  type: 'number',
}))`
  font-size: ${themeGet.fontSize(4)};
  border-bottom: 1px solid ${themeGet.colors('swirl')};
  ${hideNumberInputSpinner}
`;

export const NumberInputContainer = styled.div`
  position: relative;
`;

export const NumberInputUnit = styled.span`
  position: absolute;
  right: 0;
  bottom: 1px;
  font-size: inherit;
`;

export const NumberInput: React.FC<NumberInputProps> = ({ unit, value, ...inputAttributes }) => (
  <NumberInputContainer>
    <NumberInputStyled {...inputAttributes} value={value !== undefined && !Number.isNaN(value) ? value : ''} />
    {unit && <NumberInputUnit>{unit}</NumberInputUnit>}
  </NumberInputContainer>
);
